import { HttpClient } from '../../httpClient'

type TrackActionData = {
  [key: string]: any
}

type TrackResponse = {
  error: null | Error
  status: 'ok'
}

export function createTrackAction(
  requestBody: TrackActionData
): Promise<TrackResponse> {
  const url = new URL('log/track_action', window.location.origin)

  return HttpClient()
    .post(url.toString(), requestBody)
    .then((res) => res.data)
}
